export const initialState = {
    abTestVariant: undefined,
    hideDevMode: false,
    appData: {},
    quizData: {},
    remotePageContent: {},
    upsellsPageData: {},
    feedbackData: {},
    componentsData: [],
    newPageReviews: [],
    newPageVideoReviews: [],
    paymentButtons: {},
    optionTextData: {},
    apiGeoUrl: "",
    countryCode: "",
    redirectUrl: "",
    emailProviders: {},
    abTestCampaignName: null,
    abTestStartCampaignDate: null,
    emailsToDisableAnalyticsEvent: [],
    QAtimerTime: 0,
    isConfigReady: false,
    flowUseABtest: null,
    enableUpsells: null,
    pathPrefix: "",
    peopleOnWaitlist: 0,
    flowData: {},
    analyticsData: {},
    disclaimerText: [] || "",
    disclaimerOneTimeText: [] || "",
    shouldUseAbTestFlag: null
};